import { useQuery } from '@tanstack/react-query';
import { useAppConfigContext } from '@/context/AppConfig';
import { request } from '@/utils/index';

export function useVehicleDisclaimer(requestCallback = getDisclaimer) {
  const { logError } = useAppConfigContext();

  const result = useQuery({
    queryKey: ['vehicleDisclaimer'],
    queryFn: requestCallback,
    onError: (error) => {
      logError('Error fetching vehicle disclaimer', error as Error);
    },
  });

  return { ...result };
}

async function getDisclaimer() {
  const response = await request('/info/index.json', {
    headers: new Headers({
      'content-type': 'application/x-www-form-urlencoded',
    }),
    method: 'GET',
  });

  return response;
}
